import { api } from '@/shared/lib/api';

export async function fetchUsers(params?: { userId?: string; email?: string }) {
  return api.getUsers(params);
}

export async function createUser(name: string, email: string, roleId?: string) {
  return api.createUser(name, email, roleId);
}

export async function deleteUser(userId: string) {
  return api.deleteUser(userId);
}
